export default __webpack_public_path__ + "static/media/beef_greens.743cdfbe.jpg";